module.exports = __webpack_public_path__ + "img/news4.8a8a74c5.png";